import { request } from '@/shared/api';
export function fetchPendingFeedback() {
    return request('/api/v1/feedback/pending?limit=100');
}
export function submitFeedback(feedbackId, payload) {
    return request('/api/v1/feedback', {
        method: 'POST',
        body: JSON.stringify({ feedbackId, payload }),
    });
}
export function fetchQuestionnaireSchema() {
    return request('/api/v1/surveys/agent-questionnaire/schema');
}
export function submitQuestionnaire(agentId, answers) {
    return request('/api/v1/surveys/agent-questionnaire', {
        method: 'POST',
        body: JSON.stringify({ agentId, answers }),
    });
}
